import { AiOutlineInstagram } from "react-icons/ai"
import { AiOutlineFacebook } from "react-icons/ai"
import { AiOutlineTwitter } from "react-icons/ai"
import { AiOutlineLinkedin } from "react-icons/ai"


const data = [
    { id: 1, link: "https://instagram.com/elvizier", icon: <AiOutlineInstagram /> },
    { id: 2, link: "https://facebook.com/batkid", icon: <AiOutlineFacebook /> },
    { id: 3, link: "https://twitter.com/elvizier", icon: <AiOutlineTwitter /> },
    { id: 4, link: "https://linkedin.com/in/makinde-adeyinka-0a1173225", icon: <AiOutlineLinkedin /> }
]


export default data;